/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

var SdxAccordion = require('sdx/accordion/Accordion').default;

(function (Module, $, SCS) {
	'use strict';

	/**
	 * SDXAccordion.
	 *
	 * @author TAABANI9
	 * @namespace Tc.Module
	 * @class SDXAccordion
	 * @extends Tc.Module
	 */

	Module.SDXAccordion = Module.extend({

		/**
		 * Does all the work.
		 *
		 * @method on
		 * @param {Function} callback function
		 * @return void
		 */
		on: function (callback) {
			new SdxAccordion(this.$ctx[0]);
			this.accordionId = this.$ctx.data('accordionId');
			this.$tabs = this.$ctx.find('.accordion__item');
			if (this.accordionId) {
				var openTabIndex = parseInt(SCS.HashDeepLink.get(this.accordionId), 10);
				if ((openTabIndex === 0 || openTabIndex) && openTabIndex < this.$tabs.length) {
					this.setDefaultOpenStates(this.$tabs, openTabIndex);
				}
				this.$tabs.on('click', this.handleTabClicked.bind(this));
			}
			this.$tabs.on('click', this.handleTracking.bind(this));

			callback();
		},

		/**
		 * Set hash on clicked tab.
		 *
		 * @method handleTabClicked
		 * @param event
		 * @return void
		 */
		handleTabClicked: function (event) {
			var target = $(event.currentTarget);
			var index = this.$tabs.index(target);

			if ($(target).hasClass('is-open')) {
				SCS.HashDeepLink.set(this.accordionId, index);
			} else {
				SCS.HashDeepLink.set(this.accordionId, '');
			}
		},

		/**
		 * Tab class toggle.
		 *
		 * @method setDefaultOpenStates
		 * @param $tabs
		 * @param openTabIndex
		 * @return void
		 */
		setDefaultOpenStates: function ($tabs, openTabIndex) {
			$tabs.each(function (index, tab) {
				var $tab = $(tab);
				$tab.toggleClass('is-open', (index === openTabIndex));
				$tab.find('.accordion__collapse').toggleClass('is-open', (index === openTabIndex));
			});
		},

		handleTracking: function (event) {
			var target = $(event.currentTarget);
			var trackLabel = target.data('track-label'),
				trackCategory = target.data('track-category');

			if ($(target).hasClass('is-open')) {
				//(action, label, location, category, linkName)
				SCS.portal.datalayer.trackEvent('open', trackLabel, SCS.datalayer.getAnalyticsPageName(), trackCategory);
			} else {
				SCS.portal.datalayer.trackEvent('close', trackLabel, SCS.datalayer.getAnalyticsPageName(), trackCategory);
			}
		}

	});
}(window.Tc.Module, window.Tc.$, window.SCS = window.SCS || {}));
}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/portal/clientlibs/sdx_expand/js/modules/Tc.Module.SDXAccordion.js
// module id = 369
// module chunks = 0